import React from "react";
import TextCell from "../gridCells/TextCell";

export default function EphemeralData(props: {}) {
  return <TextCell text="Game Data" dataTest="game-data" />;
}
